import React from 'react'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'
import { dateFormat } from 'helpers/date'
import style from './WorkTimeInfo.module.scss'

const WorkTimeInfo = (props) => {
  let dayWeek
  if (props.translate.days_week)
    dayWeek = props.translate.days_week[props.today.getDay()]

  function convertMilliseconds(milliseconds) {
    if (milliseconds > 0) {
      const totalSeconds = Math.floor(milliseconds / 1000)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60
      return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`
    } else {
      return '00:00:00'
    }
  }
  const getRemainderTime = () => {
    if (
      props.currentDay.finish_at &&
      props.currentDay.finish_at !== '00:00:00'
    ) {
      const finishTime = new Date(
        `${props.currentDay.date}T${props.currentDay.finish_at}`,
      )
      const diff = finishTime - props.today
      return diff > 0 ? convertMilliseconds(diff) : '00:00:00' // если время закончилось, показать 00:00:00
    } else {
      return '00:00:00'
    }
  }
  const getOutTime = () => {
    const lunchTime = props.currentDay.lunch * 60 * 1000
    if (
      props.currentDay.start_at &&
      props.currentDay.start_at !== '00:00:00' &&
      props.currentDay.finish_at &&
      props.currentDay.finish_at !== '00:00:00'
    ) {
      const startTime = new Date(
        `${props.currentDay.date}T${props.currentDay.start_at}`,
      )
      const finishTime = new Date(
        `${props.currentDay.date}T${props.currentDay.finish_at}`,
      )
      // Если текущее время уже больше или равно времени окончания
      if (props.today >= finishTime) {
        const totalWorked = finishTime - startTime - lunchTime
        return convertMilliseconds(totalWorked)
      }
      // Если текущее время между началом и окончанием рабочего дня
      if (props.today >= startTime) {
        const workedSoFar =
          props.today - startTime - (props.today >= finishTime ? lunchTime : 0)
        return convertMilliseconds(workedSoFar)
      }
      // Если текущее время раньше начала рабочего дня
      return '00:00:00'
    } else {
      return '00:00:00'
    }
  }

  return (
    <div className={style.workTimeInfo}>
      <div className={style.workTimeInfo__header}>
        {`${props.translate.today}, ${dayWeek} ${timeConverter(new Date(), 'clean_data')}`}
      </div>
      <div className={style.remainderForToday}>
        <div className={style.timeWork}>
          <div className={style.timeWorkItem}>
            <span>{props.translate.remainder_for_today}</span>
            <span>
              {' '}
              <b>{getRemainderTime()}</b>
            </span>
          </div>
          <div className={style.timeWorkItem}>
            <span>{props.translate.worked_out_today}</span>
            <span>
              {' '}
              <b>{getOutTime()}</b>
            </span>
          </div>
        </div>
        <div>
          <div className={style.exemplaryTime}>
            <span>{props.translate.estimated_day_time}:</span>
            <div className={style.workedOutToday}>
              <span>
                {dateFormat(
                  new Date(
                    `${props.currentDay.date}T${props.currentDay.finish_at}`,
                  ),
                  'hh:ii:ss',
                  '00:00:00',
                )}
              </span>
              <span>{dateFormat(props.today)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WorkTimeInfo
